/**
 * UNiKtee Path Selection Landing Page
 * Premium Interactive Enhancements
 */

(function() {
    'use strict';

    // ==================== Configuration ====================
    const config = {
        preloadOnHover: true,
        enableSmoothTransition: false,
        transitionDuration: 300,
        enable3DTilt: true,
        tiltIntensity: 5
    };

    // ==================== DOM Elements ====================
    const pathCards = document.querySelectorAll('.path-card');
    const page = document.querySelector('.path-selection-page');

    // ==================== Preload Target Pages ====================
    // Preload target pages on hover for faster navigation
    if (config.preloadOnHover) {
        pathCards.forEach(card => {
            card.addEventListener('mouseenter', function() {
                const targetUrl = this.getAttribute('href');
                preloadPage(targetUrl);
            }, { once: true }); // Only preload once per card
        });
    }

    function preloadPage(url) {
        if (!url || url.startsWith('#')) return;

        // Create a link preload element
        const link = document.createElement('link');
        link.rel = 'prefetch';
        link.href = url;
        link.as = 'document';
        document.head.appendChild(link);
    }

    // ==================== Smooth Page Transition ====================
    if (config.enableSmoothTransition) {
        pathCards.forEach(card => {
            card.addEventListener('click', function(e) {
                e.preventDefault();
                const targetUrl = this.getAttribute('href');

                // Add fade-out effect
                page.style.transition = `opacity ${config.transitionDuration}ms ease-out`;
                page.style.opacity = '0';

                // Navigate after transition
                setTimeout(() => {
                    window.location.href = targetUrl;
                }, config.transitionDuration);
            });
        });
    }

    // ==================== Cursor-Following Gradient Effect ====================
    // Premium cursor-tracking glow effect
    if (window.matchMedia('(hover: hover)').matches) {
        pathCards.forEach(card => {
            card.addEventListener('mousemove', handleCursorGlow);
            card.addEventListener('mouseleave', resetCursorGlow);
        });
    }

    function handleCursorGlow(e) {
        const card = e.currentTarget;
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        card.style.setProperty('--mouse-x', `${x}px`);
        card.style.setProperty('--mouse-y', `${y}px`);
    }

    function resetCursorGlow(e) {
        const card = e.currentTarget;
        card.style.removeProperty('--mouse-x');
        card.style.removeProperty('--mouse-y');
    }

    // ==================== 3D Card Tilt Effect ====================
    if (config.enable3DTilt && window.matchMedia('(hover: hover)').matches) {
        pathCards.forEach(card => {
            card.addEventListener('mousemove', handleCardTilt);
            card.addEventListener('mouseleave', resetCardTilt);
        });
    }

    function handleCardTilt(e) {
        const card = e.currentTarget;
        const rect = card.getBoundingClientRect();

        // Calculate mouse position relative to card center
        const cardCenterX = rect.left + rect.width / 2;
        const cardCenterY = rect.top + rect.height / 2;
        const mouseX = e.clientX;
        const mouseY = e.clientY;

        // Calculate rotation angles
        const rotateY = ((mouseX - cardCenterX) / (rect.width / 2)) * config.tiltIntensity;
        const rotateX = -((mouseY - cardCenterY) / (rect.height / 2)) * config.tiltIntensity;

        // Apply transform
        card.style.transform = `translateY(-8px) perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
    }

    function resetCardTilt(e) {
        const card = e.currentTarget;
        card.style.transform = '';
    }

    // ==================== Keyboard Navigation Enhancement ====================
    pathCards.forEach(card => {
        card.addEventListener('keydown', function(e) {
            // Activate card on Enter or Space
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                this.click();
            }
        });
    });

    // ==================== Accessibility: Screen Reader Announcements ====================
    // Announce page load for screen readers
    const srAnnouncement = document.createElement('div');
    srAnnouncement.setAttribute('role', 'status');
    srAnnouncement.setAttribute('aria-live', 'polite');
    srAnnouncement.style.position = 'absolute';
    srAnnouncement.style.left = '-10000px';
    srAnnouncement.style.width = '1px';
    srAnnouncement.style.height = '1px';
    srAnnouncement.style.overflow = 'hidden';
    document.body.appendChild(srAnnouncement);

    window.addEventListener('load', () => {
        srAnnouncement.textContent = 'Choisissez votre espace: Particulier ou Professionnel';
    });

    // ==================== Performance: Reduce Motion Preference ====================
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion) {
        // Disable 3D tilt for users who prefer reduced motion
        config.enable3DTilt = false;
        config.transitionDuration = 0;
    }

    // ==================== Analytics Helper (Optional) ====================
    // Track which path users choose - can be integrated with GA4, Shopify Analytics, etc.
    pathCards.forEach(card => {
        card.addEventListener('click', function() {
            const pathType = this.classList.contains('path-card--particulier') ? 'Particulier' : 'Professionnel';

            // Example: Send to Google Analytics (if available)
            if (typeof gtag !== 'undefined') {
                gtag('event', 'path_selection', {
                    'event_category': 'Navigation',
                    'event_label': pathType,
                    'value': pathType === 'Particulier' ? 1 : 2
                });
            }

            // Example: Send to Shopify Analytics (if available)
            if (typeof window.ShopifyAnalytics !== 'undefined') {
                window.ShopifyAnalytics.lib.track('Path Selection', {
                    path: pathType
                });
            }

            // Console log for debugging
            console.log(`User selected: ${pathType} path`);
        });
    });

    // ==================== Mobile Touch Enhancement ====================
    // Add subtle haptic feedback on mobile (if supported)
    if ('vibrate' in navigator) {
        pathCards.forEach(card => {
            card.addEventListener('touchstart', function() {
                navigator.vibrate(10); // Very subtle 10ms vibration
            });
        });
    }

    // ==================== Browser Support Detection ====================
    // Check for CSS custom properties support
    const supportsCSSVariables = window.CSS && window.CSS.supports && window.CSS.supports('(--fake-var: 0)');

    if (!supportsCSSVariables) {
        console.warn('CSS custom properties not supported. Design may not render correctly.');
        // Fallback could be added here for older browsers
    }

    // ==================== Page Visibility: Pause Animations ====================
    // Pause any animations when page is not visible (performance optimization)
    document.addEventListener('visibilitychange', function() {
        if (document.hidden) {
            page.style.animationPlayState = 'paused';
        } else {
            page.style.animationPlayState = 'running';
        }
    });

    // ==================== Floating Background Words ====================
    // Multiple words floating in different directions
    const floatingWords = document.querySelector('.floating-words');

    if (floatingWords && !prefersReducedMotion) {
        console.log('✨ Floating background words active');
    }

    // ==================== Development Helper ====================
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        console.log('🎨 UNiKtee Path Selection Page - Development Mode');
        console.log('Configuration:', config);
        console.log('Reduced Motion:', prefersReducedMotion);
    }

})();
